import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles'
import Grid from 'material-ui/Grid'
import Typography from 'material-ui/Typography/Typography'

import {
  capitalize
} from '../../utils/helpers'

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.default, // toggle this to get two-tone background
  },
  sectionWrapper: {
    // TODO pass padding in as prop
    padding: "50px"
  },
  sectionImg: {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    height: 'auto',
    padding: '5%'
  },
})

const InfoSection1 = ({
  classes,
  isFullScreen,
  title,
  subTitle,
  descHeading,
  description,
  direction,
  image,
  altText,
}) => (
    <Grid
      item
      xs={isFullScreen ? 12 : 10}
      className={classes.root}
    >
      <Grid
        container
        spacing={0}
        className={classes.sectionWrapper}
        alignItems="center"
        direction={direction}
      >

        {/* Title and/or Sub Title */}
        <Grid item xs={12}>

          {title && typeof title === 'string' &&
            <Typography
              variant="display1"
              component="h2"
              align="center"
              gutterBottom
            >
              {capitalize(title)}
            </Typography>
          }
          {title && typeof title === 'function' &&
            <Typography
              variant="display1"
              component="h2"
              align="center"
              gutterBottom
            >
              {title()}
            </Typography>
          }
          {title && typeof title === 'object' &&
            <Typography
              variant="display1"
              component="h2"
              align="center"
              gutterBottom
            >
              {title}
            </Typography>
          }

          {subTitle && typeof subTitle === 'string' &&
            <Typography
              variant="headline"
              component="h3"
              align="center"
              gutterBottom
            >
              {subTitle}
            </Typography>
          }
          {subTitle && typeof subTitle === 'function' &&
            <Typography
              variant="headline"
              component="h3"
              align="center"
              gutterBottom
            >
              {subTitle()}
            </Typography>
          }
          {subTitle && typeof subTitle === 'object' &&
            <Typography
              variant="headline"
              component="h3"
              align="center"
              gutterBottom
            >
              {subTitle}
            </Typography>
          }
        </Grid>

        {/* Section Image */}
        <Grid item xs={12} md={6}>
          <img
            src={image}
            alt={altText}
            className={classes.sectionImg}
          />
        </Grid>

        {/* Section Description */}
        <Grid item xs={12} md={6}>
          {descHeading && typeof descHeading === 'string' &&
            <Typography
              variant="title"
              component="h4"
              align="center"
              gutterBottom
              className={classes.descHeading}
            >
              {descHeading}
            </Typography>
          }
          {descHeading && typeof descHeading === 'function' &&
            <Typography
              variant="title"
              component="h4"
              align="center"
              gutterBottom
              className={classes.descHeading}
            >
              {descHeading()}
            </Typography>
          }
          {descHeading && typeof descHeading === 'object' &&
            <Typography
              variant="title"
              component="h4"
              align="center"
              gutterBottom
              className={classes.descHeading}
            >
              {descHeading}
            </Typography>
          }

          {description && typeof description === 'string' &&
            <Typography
              variant="subheading"
              component="p"
              align="center"
            >
              {description}
            </Typography>
          }
          {description && typeof description === 'function' &&
            <Typography
              variant="subheading"
              component="p"
              align="center"
            >
              {description()}
            </Typography>
          }
          {description && typeof description === 'object' &&
            <Typography
              variant="subheading"
              component="p"
              align="center"
            >
              {description}
            </Typography>
          }
        </Grid>

      </Grid>
    </Grid>
  )

InfoSection1.propTypes = {
  classes: PropTypes.object.isRequired,
  isFullScreen: PropTypes.bool.isRequired,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object
  ]),
  subTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object
  ]),
  descHeading: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object
  ]),
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object
  ]),
  image: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
};

export default withStyles(styles)(InfoSection1)


// WEBPACK FOOTER //
// ./src/components/sections/InfoSection1.js